import React from "react";
import Aux from "../utils/AuxFunctions";
// import "./Register.css"
import "./Account.css"
import Fire from "../config/Fire";
import InstagramIcon from "mdi-react/InstagramIcon"
import TwitterIcon from "mdi-react/TwitterIcon"
import SnapchatIcon from "mdi-react/SnapchatIcon"
import YoutubeIcon from "mdi-react/YoutubeIcon"
import FacebookIcon from "mdi-react/FacebookIcon"
import { withMyDataContext } from "../context/DataProvider";
import ButtonLoader from "../utils/Utilities/ButtonLoader";
import Colors from "../utils/Colors";
import ErrorMessage from "../utils/ErrorPages/ErrorMessage";
import SucessMessage from "../utils/ErrorPages/SucessMessage";
import ChevronLeftIcon from "mdi-react/ChevronLeftIcon";
import TextInputMaterial from "../utils/Utilities/TextInputMaterial";
import LoadingHelper from "../utils/Utilities/LoadingHelper";
class EditProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            user: this.props.myDataProvider.user,
            //avatar: "../../assets/tempAvatar.jpg",
            username: "",
            avatar: "",

            deleteAvatar: false,
            name: "",
            bio: "",
            website: "",
            //facebook: "",

            instagram: "",
            twitter: "",
            snapchat: "",
            youtube: "",
            facebook: "",

            isLoading: false,
            skipText: true,
            usernameError: "",
            selectedPhoto: null,
            uploadedPhoto: null,
            sucess: false,
            addInfo: false,
        }
    }

    componentDidMount() {
        try {
            if (this.props.location.state) {
                this.setState({ addInfo: this.props.location.state.addInfo })
            }
            this.init()
        } catch (error) {
            Aux.handleError(error);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.myDataProvider.user !== null && prevState.user !== this.props.myDataProvider.user) {
            this.init()
        }
    }

    init = () => {
        const user = this.props.myDataProvider.user
        if (user) {
            this.setState({
                user: user,
                username: user.username || "",
                avatar: user.avatar || "",
                name: user.name || "",
                bio: user.bio || "",
                website: user.website || "",
                //facebook: user.facebook,
                instagram: user.instagram || "",
                twitter: user.twitter || "",
                snapchat: user.snapchat || "",
                youtube: user.youtube || "",
                facebook: user.facebook || "",
            })
        }
    }

    handleUpdate = async () => {
        if (this.state.isLoading) {
            return;
        }
        let userNameUpdated = false;

        const { username, avatar, name, bio, website, instagram, twitter, snapchat, youtube, facebook, deleteAvatar } = this.state
        this.setState({ isLoading: true });

        try {
            if (username) {
                if (username !== this.props.myDataProvider.user.username) {
                    if (username.length < 5) {
                        this.setState({ isLoading: false, usernameError: "username is too short" });
                        return;
                    } else if (/[^A-Z0-9._-]/gi.test(username)) {
                        this.setState({ isLoading: false, usernameError: 'username can only have ".", "-" and "_"' });
                        return;
                    }

                    let userAvailable = await Fire.shared.CheckIfUsernameExists(username.toLowerCase())
                    if (!userAvailable) {
                        this.setState({ isLoading: false, usernameError: "username already exists" });
                        return;
                    } else {
                        userNameUpdated = true;
                    }
                }
            }
            await Fire.shared.UpdateUserInfo({
                user: this.props.myDataProvider.user,
                username: userNameUpdated ? username.toLowerCase() : "",
                avatar: avatar,
                name: name,
                bio: bio,
                website: website,
                twitter: twitter,
                instagram: instagram,
                snapchat: snapchat,
                youtube: youtube,
                facebook: facebook,
                deleteAvatar: deleteAvatar,
            }).then(() => {
                this.setState({ isLoading: false, sucess: true });

                //this.props.myDataProvider.updateUser(Fire.shared.user);
            }).catch(error => {
                this.setState({ isLoading: false, usernameError: "An unexpected error has occurred" });
                Aux.handleError(error)
            })
        } catch (error) {
            this.setState({ isLoading: false, usernameError: "An unexpected error has occurred" });
            Aux.handleError(error)
        }
    }

    deleteAvatar = () => {
        this.setState({ deleteAvatar: true, avatar: "", selectedPhoto: "" });
    }

    photoSelectedHandler = (event) => {
        let photo = URL.createObjectURL(event.target.files[0])
        this.setState({ selectedPhoto: photo, avatar: event.target.files[0] })
    }

    goBack = () => {
        try {
            this.props.history.goBack();
        } catch (error) {
            Aux.handleError(error)
        }
    }

    goToMyPage = () => {
        try {
            this.props.history.push("/account/profile")
        } catch (error) {
            Aux.handleError(error)
        }
    }

    goToMainPage = () => {
        try {
            this.props.history.push("/")
        } catch (error) {
            Aux.handleError(error)
        }
    }
    onChangedUsername(text) {
        //let num = text.replace(/[^0-9]/g, '')
        let username = text.replace(/[^a-zA-Z0-9-_.]/g, '')
        this.setState({
            username: username, userNameUpdated: true
        });
    }

    render() {
        return (
            <div style={{ width: "100%" }}>
                <section className="container">
                    {this.state.addInfo ? 
                    <div style={{  display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                        <h2>Add your information</h2>
                        <div className="text-hover" style={{ margin: "20px 0", display: "flex", justifyContent: "flex-end" }}
                            onClick={this.goToMainPage}>
                            <span style={{ color: Colors.middleText }}>Skip</span>
                        </div>
                    </div> :
                        <div className="reversed-button-hover" style={{ display: "flex", alignItems: "center" }} onClick={this.goBack}>
                            <ChevronLeftIcon style={{ marginRight: 5 }}></ChevronLeftIcon>
                            <h2>Edit Profile</h2>
                        </div>
                    }
                    {this.props.myDataProvider.user ?
                        <div>
                            <label htmlFor="file" className="custom-file-upload" >
                                <img style={{ height: 60, width: 60, borderRadius: 50, objectFit: "cover", marginTop: 20, marginBottom: 5 }}
                                    src={this.state.selectedPhoto ? this.state.selectedPhoto : (this.state.avatar ? this.state.avatar : Aux.TemporaryImage)} alt="avatar">
                                </img>
                                <span className="text-hover">Upload photo</span>

                            </label>
                            <input id="file" type="file" className="file-upload" onChange={this.photoSelectedHandler} />
                            {this.state.selectedPhoto || this.state.avatar ?
                                <div style={{ display: "flex", justifyContent: "center", marginTop: 5 }}>
                                    <span className="text-hover" style={{ color: Colors.red, }} onClick={this.deleteAvatar}>Remove photo</span>
                                </div> : null}
                            <div style={{ marginTop: 20 }}>
                                <ErrorMessage text={this.state.usernameError}></ErrorMessage>
                                {/* {this.state.usernameError ? <span className="login-error">{this.state.usernameError}</span> : null} */}
                                {this.state.addInfo ? null :
                                    <div>
                                        {/* <span style={{marginBottom:3}}>Username</span> */}
                                        <TextInputMaterial maxLength={30} type="text" title="Username" placeholder="Username"
                                            value={this.state.username || ""} style={{ marginTop: 15 }}
                                            onChange={(e) => {
                                                this.onChangedUsername(e.target.value)
                                            }} />
                                    </div>}
                                {/* <span style={{marginBottom:3}}>Name</span> */}
                                <TextInputMaterial maxLength={60} type="text" title="Name" placeholder="Name"
                                    value={this.state.name || ""} style={{ marginTop: 15 }}
                                    onChange={(e) => {
                                        this.setState({ name: e.target.value });
                                    }} />
                                {/* <span style={{marginBottom:3}}>Bio</span> */}
                                <TextInputMaterial maxLength={200} type="text" title="Bio" placeholder="Bio"
                                    value={this.state.bio || ""} style={{ marginTop: 15 }}
                                    onChange={(e) => {
                                        this.setState({ bio: e.target.value });
                                    }} />
                                {/* <span style={{marginBottom:3}}>Website</span>    */}
                                <TextInputMaterial maxLength={100} type="text" title="Website" placeholder="Url"
                                    value={this.state.website || ""} style={{ marginTop: 15 }}
                                    onChange={(e) => {
                                        this.setState({ website: e.target.value });
                                    }} />
                                <div style={{ marginBottom: 10, marginTop: 20 }}>
                                    <span style={{ color: "#777", }}>Social Media</span>
                                </div>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <InstagramIcon size={30} style={{ marginRight: 10 }}></InstagramIcon>
                                    <span>instagram.com/</span>
                                    <TextInputMaterial maxLength={50} type="text" placeholder="Add your username"
                                        value={this.state.instagram || ""} style={{ marginLeft: 10, width: "100%" }}
                                        onChange={(e) => {
                                            this.setState({ instagram: e.target.value });
                                        }} />
                                </div>

                                <div style={{ display: "flex", alignItems: "center", marginTop: 10 }}>
                                    <TwitterIcon size={30} style={{ marginRight: 10 }}></TwitterIcon>
                                    <span>twitter.com/</span>
                                    <TextInputMaterial maxLength={50} type="text" placeholder="Add your username"
                                        value={this.state.twitter || ""} style={{ marginLeft: 10, width: "100%" }}
                                        onChange={(e) => {
                                            this.setState({ twitter: e.target.value });
                                        }} />
                                </div>

                                <div style={{ display: "flex", alignItems: "center", marginTop: 10 }}>
                                    <YoutubeIcon size={30} style={{ marginRight: 10 }}></YoutubeIcon>
                                    <span>youtube</span>
                                    <TextInputMaterial maxLength={50} type="text" placeholder="Add your youtube link"
                                        value={this.state.youtube || ""} style={{ marginLeft: 10, width: "100%" }}
                                        onChange={(e) => {
                                            this.setState({ youtube: e.target.value });
                                        }} />
                                </div>
                                <div style={{ display: "flex", alignItems: "center", marginTop: 10 }}>
                                    <FacebookIcon size={30} style={{ marginRight: 10 }}></FacebookIcon>
                                    <span>facebook.com/</span>
                                    <TextInputMaterial maxLength={50} type="text" placeholder="Add your username"
                                        value={this.state.facebook || ""} style={{ marginLeft: 10, width: "100%" }}
                                        onChange={(e) => {
                                            this.setState({ facebook: e.target.value });
                                        }} />
                                </div>
                                <div style={{ display: "flex", alignItems: "center", marginTop: 10 }}>
                                    <SnapchatIcon size={30} style={{ marginRight: 10 }}></SnapchatIcon>
                                    <span>snapchat.com/</span>
                                    <TextInputMaterial maxLength={50} type="text" placeholder="Add your username"
                                        value={this.state.snapchat || ""} style={{ marginLeft: 10, width: "100%" }}
                                        onChange={(e) => {
                                            this.setState({ snapchat: e.target.value });
                                        }} />
                                </div>
                                <SucessMessage isSucess={this.state.sucess} text="Your user was updated sucessfully"></SucessMessage>
                                <ButtonLoader
                                    text={this.state.addInfo ? "Update information" : "Edit Profile"}
                                    loading={this.state.isLoading}
                                    onClick={this.handleUpdate}
                                    style={{ backgroundColor: Colors.mainColor, width: "100%", height: 45, marginTop: 20 }}
                                ></ButtonLoader>
                                {this.state.addInfo ?
                                    <div onClick={this.goToMainPage} className="text-hover" style={{ margin: "20px 0", display: "flex", justifyContent: "center" }} >
                                        <span style={{ color: Colors.middleText }}>Skip</span>
                                    </div>
                                    : null}
                            </div>
                        </div> :
                        <LoadingHelper />
                    }
                </section>

            </div>
        );
    }
}

export default withMyDataContext(EditProfile);